import { Box, Typography } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';

const FinancialManagementPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" color="text.primary" gutterBottom>
          Financial Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Financial management content will be implemented here.
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default FinancialManagementPage; 